import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { TID } from "@/lib/testIds";
import { formatEUR, formatDate, statusClass } from "@/lib/format";
import { ArrowRight } from "lucide-react";

export default function Quotes() {
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    api
      .get("/quotes")
      .then((r) => setQuotes(r.data))
      .catch((e) => setErr(e?.response?.data?.detail || e.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid={TID.quotesPage} className="space-y-4">
      <p className="text-sm text-neutral-400 max-w-2xl">
        Preventivi generati dai lead. Ogni preventivo mostra voci, importi, IVA, totale.
      </p>

      {err && (
        <div className="border border-red-900/60 bg-red-950/20 px-4 py-3 font-mono text-xs text-red-300">
          {err}
        </div>
      )}

      <div className="border border-[#1F1F1F] bg-[#0C0C0C]">
        <header className="border-b border-[#1F1F1F] px-4 py-3 flex items-center justify-between bg-[#141414]">
          <span className="font-mono text-[10px] tracking-[0.24em] uppercase text-neutral-400">
            preventivi
          </span>
          <span className="font-mono text-[10px] text-neutral-600">{quotes.length} items</span>
        </header>
        <table data-testid={TID.quotesTable} className="w-full">
          <thead>
            <tr className="border-b border-[#1F1F1F] font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500">
              <th className="text-left px-4 py-2">ID</th>
              <th className="text-left px-4 py-2">Cliente</th>
              <th className="text-left px-4 py-2 hidden md:table-cell">Progetto</th>
              <th className="text-right px-4 py-2">Totale</th>
              <th className="text-left px-4 py-2">Stato</th>
              <th className="text-left px-4 py-2 hidden lg:table-cell">Data</th>
              <th className="text-right px-4 py-2"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#1F1F1F]">
            {loading && (
              <tr>
                <td colSpan={7} className="px-4 py-6 font-mono text-xs text-neutral-500">
                  <span className="cursor-blink">LOADING</span>
                </td>
              </tr>
            )}
            {!loading && quotes.length === 0 && (
              <tr>
                <td colSpan={7} className="px-4 py-6 font-mono text-xs text-neutral-500">
                  Nessun preventivo. Genera dal dettaglio lead.
                </td>
              </tr>
            )}
            {quotes.map((q) => (
              <tr key={q.id} data-testid={TID.quoteRow} className="hover:bg-[#141414]">
                <td className="px-4 py-3 font-mono text-xs text-neutral-300">{q.id}</td>
                <td className="px-4 py-3 text-sm">
                  <Link to={`/app/quotes/${q.id}`} className="text-[#EDEDED] underline decoration-neutral-700 hover:decoration-[#EDEDED] underline-offset-2">
                    {q.client_name}
                  </Link>
                </td>
                <td className="px-4 py-3 text-sm text-neutral-400 hidden md:table-cell">
                  {q.project_name}
                </td>
                <td className="px-4 py-3 font-mono text-xs text-right">
                  {formatEUR(q.total_eur)}
                </td>
                <td className="px-4 py-3">
                  <span className={`font-mono text-[9px] uppercase tracking-widest border px-1.5 py-0.5 ${statusClass(q.status)}`}>
                    {q.status}
                  </span>
                </td>
                <td className="px-4 py-3 font-mono text-[11px] text-neutral-500 hidden lg:table-cell">
                  {formatDate(q.created_at)}
                </td>
                <td className="px-4 py-3 text-right">
                  <Link
                    to={`/app/quotes/${q.id}`}
                    className="inline-flex items-center gap-1 font-mono text-[10px] uppercase tracking-widest text-neutral-400 hover:text-[#EDEDED]"
                  >
                    Apri
                    <ArrowRight className="w-3.5 h-3.5" strokeWidth={1.5} />
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
